module.exports = __webpack_public_path__ + "static/media/medixine-doctor-computer.90924260.svg";